import type {ExtraInfo} from './types';

const DATA: ExtraInfo = {
  surveyUrl: '',
  checkInCode: '7892',
  details: [
    {
      type: 'description',
      heading: 'イベント概要',
      paragraphs: [
        {
          content:
            '今年も夏が近づいてきましたね。梅雨が始まり、なかなか外出しづらいですよね？また、仕事や勉強で忙しく、運動不足になっていませんか？暑くなる前に一緒に集まりませんか？',
        },
        {
          content:
            '7月6日に美しい奥多摩の自然を探検しませんか。初心者向けのウォーキングイベントで、徒歩1時間半の御岳渓谷遊歩道コースを予定しています。歩きながら、おしゃべりして、一緒に楽しみましょう。ウォーキングセッションの後はバーベキューを予定していますが、参加は自由です。周辺には美術館やカフェなどもありますので、お好きな時間をお過ごしいただけます。',
        },
        {
          content:
            '参加は学生、社会人、どなたでも歓迎です。分野や経験年数に関係なくご参加いただけます。参加枠に限りがあるため、先着順となりますので、まだ登録されていない方は、ぜひ登録の上、メンバープロフィールを設定してください。',
        },
      ],
    },
    {type: 'registration-form'},
    {
      type: 'list',
      heading: 'こんな方におすすめ',
      items: [
        'キャリアデザインに関する目標とアドバイスを求めている方',
        'メンターシップの機会に興味がある方',
        'ネットワーキングの機会を求めている方',
        '就職・転職活動の準備をしている方',
        'allizに興味がある方',
      ],
    },
    {
      type: 'schedule',
      heading: 'タイムテーブル',
      items: [
        {
          timeUTC: 1751760000,
          description: 'JR御嶽（みたけ）駅前に集合（時間厳守）',
        },
        {
          timeUTC: 1751760600,
          description: '出発・御岳渓谷遊歩道を散策',
        },
        {
          timeUTC: 1751766000,
          description: '休憩・昼食（清流ガーデン 澤乃井園)',
        },
        {
          timeUTC: 1751769000,
          description: '現地解散・自由時間',
        },
        {
          timeUTC: 1751770800,
          info: ['※16:00まで煉瓦堂朱とんぼにてBBQを楽しみます'],
          description: '希望者のみBBQスタート（自由参加）',
        },
      ],
    },
    {
      type: 'description',
      heading: '注意事項',
      paragraphs: [
        {
          content:
            '申し込み: 参加制限人数は15名です。申し込み完了次第、カレンダー招待が送信されます。申し込み締め切りは2025年7月3日（木）です。イベントに関する詳細は、イベントの2日前にお知らせします。',
        },
        {
          content:
            'コース: 当日は御岳渓谷遊歩道を歩く予定です。スケジュールや内容は当日変更になる場合があります。また、雨天の場合、予定が変更される可能性があります。その場合、再度参加確認のご案内を差し上げます。',
        },
        {
          content:
            'BBQのご参加：BBQへの参加をご希望の方は、イベント登録後に alliz 宛にメールでご連絡ください。席に限りがございますので、先着順とさせていただきます。ご了承ください。',
        },
        {
          content:
            '参加費: 参加は無料ですが、交通費や飲食費は各自での負担となります。',
        },
        {
          content:
            '写真撮影: イベント中に写真やビデオが撮影され、allizのウェブサイトやソーシャルメディアで宣伝目的で使用される場合があります。また、本イベントに登録することで、これらの写真やビデオの使用許可を与えることになります。写真撮影には了承できないけれども、イベントに参加したいという場合には、allizにご連絡ください。',
        },
        {
          content:
            'お問い合わせ：イベントに関するお問い合わせは、alliz（event@alliz.jp）までメールでお気軽にご連絡ください。皆様のご参加を心よりお待ちしております。',
        },
      ],
    },
    {
      type: 'description',
      heading: '開催者',
      paragraphs: [
        {
          content:
            'allizは、キャリアデザインとキャリア開発に焦点を当てた、メンバーが運営するキャリアメンターシップコミュニティです。allizでは、コミュニティ主導の体験を通じて、メンターシップを育み、価値あるつながりを築くことに力を入れています。allizの独自のアプローチを通じて、学生、キャリア初期の社会人、さまざまなテック関連業界のメンターがつながり合い、互いの経験や知識、アドバイスを共有することで、参加者同士の成長と学びを促進しています。',
        },
      ],
    },
  ],
  tags: [],
  thumbnailURL: '/static/images/kMASOkQt47/nY9Mw8dnAK9K3vEj1lC62aJKZmq6EOg.png',
};

export default DATA;
